import { batch_ClusterWithSummary } from "src/api"

export interface IDateRangeFilter {
    from: Date
    to: Date
}

export interface ICommunity {
    id: number
    label: string
    internal_name: string
}

export type TCommunityPeriod = {
    value: number
    warningScore: number
    period: string
    clusters: batch_ClusterWithSummary[]
    nbrThreads: number
    nbrThreadsTopic: number
}

export interface ICommunitiesInsight {
    id: number
    name: string
    internal_name: string
    periods: TCommunityPeriod[]
}

export type IHeaders = {
    key: string
    name: string
    hidden?: boolean
}[]

export enum CommunityInsightsSeverityLevel {
    NONE = "none",
    REDUCED = "reduced",
    LOW = "low",
    MODERATED = "moderated",
    MEDIUM = "medium",
    HIGH = "high",
    SEVERE = "severe",
}
